import React from "react";
import { Gift } from "react-bootstrap-icons";

import Select from "../../../components/selects/select";
import MarcaPropriaAlert from "../../../shared/components/marca-propria/marca-propria-alert";

import styles from "./promocao-marca-propria.module.css";

const PromocaoMarcaPropria = ({ labName, promocoes, selecionada, onSelect }) => {
	if (!promocoes || promocoes.length === 0) {
		return null;
	}

	return (
		<>
			<MarcaPropriaAlert id="alert-pedido-promocional-marca-propria">
				<Gift size={16} /> Este é um <strong>pedido promocional</strong> do laboratório <strong>{labName}</strong>. É
				necessário escolher um produto elegível nesta etapa.
			</MarcaPropriaAlert>

			<h2 className="order-title">Promoção</h2>

			<div className={`x-web-ordering-pedido__lens--row ${styles.promocaoRow}`}>
				<Select
					label="Escolha a promoção*"
					width="50%"
					name="promocao_marca_propria"
					aria="Escolha a promoção"
					itens={promocoes.map(promocao => ({ label: promocao.descricao, value: String(promocao.id) }))}
					value={selecionada ? String(selecionada.id) : ""}
					onChange={evt => {
						evt.target.style.boxShadow = "0 0 0 1px #B5B5B5";
						onSelect(promocoes.find(promocao => String(promocao.id) === evt.target.value) || null);
					}}
					required
				/>
			</div>
		</>
	);
};

export default PromocaoMarcaPropria;
